const baseUrl = process.env.REACT_APP_RADAR_BASE_URL;

export const getRadarData = async awb => {
  try {
    const res = await fetch(`${baseUrl}/livetracking/tracking-awb?awb=${awb}`);
    return res.json();
  } catch (error) {
    return false;
  }
};

export const createCallSession = async tripId => {
  try {
    const res = await fetch(`${baseUrl}/livetracking/create-session?trip_id=${tripId}`);
    return res.json();
  } catch (error) {
    return false;
  }
};
